module.exports = __webpack_public_path__ + "img/01b.fe19d376.jpg";